var map = {
	"./cn/来华/wap.svg": "05vo",
	"./en/来华/wap.svg": "9Owc"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Ruxh";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\/来华\/wap\.svg$
// module id = Ruxh
// module chunks = 16